import { IconButton } from "@material-ui/core";
import React from "react";

export default function InfoIconButton({ onClick, ...props }) {
  return (
    <IconButton
      onClick={onClick}
      size="small"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...props}
    >
      <img src="/assets/info-icon-button.svg" alt="info-icon-button" />
    </IconButton>
  );
}
